// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603021304/js/" + chunkId + "." + {"44":"f47a805b","225":"c41f315f","481":"27a4fb3a","486":"e450f961","770":"d1b99910"}[chunkId] + ".0.05101662113525407.chunk.js";
};